
import { Partner } from "../entities/Partner";
import { PartnerSocketRepository } from "../repositories/PartnerSocketRepository";

export class ListenPartnerInvited {
	constructor(private repository: PartnerSocketRepository) {}
	execute(callback: (data: Partner) => void): void {
		return this.repository.listenPartnerInvited(callback);
	}
}
